// @flow

import { basename } from 'path';

import { mapValues } from 'lodash';

// Takes a `block` string and an `allStyles` object and iterates
// through all of the values in `allStyles`, adding a `label`
// key to them so emotion labels the classes nicely. If a `label`
// is already specified on a value then it'll take precedence.
const labelStyles = (block: string, allStyles: {}) => {
  block = basename(block, '.js');
  const mapped = mapValues(allStyles, (styles, name) => {
    const label = name === 'root' ? block : `${block}__${name}`;
    if (typeof styles === 'function') {
      return (...args) => [{ label }, styles(...args)];
    }
    return [{ label }, styles];
  });
  return mapped;
};

export default labelStyles;
